<div [ngClass]="{ 'dark text-white-dark': store()?.semidark }">
    <nav class="sidebar fixed top-0 bottom-0 z-50 h-full min-h-screen w-[280px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
        <div class="h-full bg-white dark:bg-[#0e1726]">
            <div class="flex items-center justify-between px-2 py-3">
                <a routerLink="/" class="main-logo flex shrink-0 items-center">
                    <img class="ml-[5px] w-8 flex-none" src="/assets/images/favicon.png" alt="" />
                    <span class="align-middle text-2xl font-extrabold ltr:ml-1.5 rtl:mr-1.5 dark:text-white-light lg:inline">ADA</span>
                </a>
                <a
                    href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})"
                >
                    <icon-arrow-left class="size-5 m-auto rotate-180" />
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 pt-2 py-0 font-normal text-[16px]">
<li class="nav-item">
                        <a routerLink="/dashboard" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-apps class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Dashboard' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item relative">
                        <a routerLink="/errors" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-info-circle [fill]="true" class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Errors' | translate }}</span
                                >
                            </div>
                            <span class="absolute right-2 bg-primary-light text-[#000] dark:text-white dark:bg-white/10 rounded-full px-1.5 py-0.5 text-xs">12</span>
                        </a>
                    </li>

                    <li class="nav-item relative">
                        <a routerLink="/contrast-error" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-charts class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Contrast Errors' | translate }}</span
                                >
                            </div>
                            <span class="absolute right-2 bg-primary-light text-[#000] dark:text-white dark:bg-white/10 rounded-full px-1.5 py-0.5 text-xs">10</span>
                        </a>
                    </li>

                    <li class="nav-item relative">
                        <a routerLink="/alerts" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-clock class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Alerts' | translate }}</span
                                >
                            </div>
                            <span class="absolute right-2 bg-primary-light text-[#000] dark:text-white dark:bg-white/10 rounded-full px-1.5 py-0.5 text-xs">03</span>
                        </a>
                    </li>

                    <li class="nav-item relative">
                        <a routerLink="/features" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-star class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Features' | translate }}</span
                                >
                            </div>
                            <span class="absolute right-2 bg-primary-light text-[#000] dark:text-white dark:bg-white/10 rounded-full px-1.5 py-0.5 text-xs">16</span>
                        </a>
                    </li>

                    <li class="nav-item relative">
                        <a routerLink="/structural-elements" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-share class="shrink-0 group-hover:!text-primary rotate-90" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Stuctural Elements' | translate }}</span
                                >
                            </div>
                            <span class="absolute right-2 bg-primary-light text-[#000] dark:text-white dark:bg-white/10 rounded-full px-1.5 py-0.5 text-xs">18</span>
                        </a>
                    </li>

                    <li class="nav-item relative">
                        <a routerLink="/aria-labels" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-bookmark class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'ARIA Labels' | translate }}</span
                                >
                            </div>
                            <span class="absolute right-2 bg-primary-light text-[#000] dark:text-white dark:bg-white/10 rounded-full px-1.5 py-0.5 text-xs">20</span>
                        </a>
                    </li>

                    <li class="nav-item relative">
                        <a routerLink="/ticket" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-code class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Ticket' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/reports" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-list-check class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Reports' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/knowledge-base" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-coffee class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Knowledge Base' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/settings" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-settings class="shrink-0 group-hover:!text-primary" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Settings' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/auth/boxed-signin" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-logout class="shrink-0 group-hover:!text-primary rotate-90" />

                                <span class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark"
                                    >{{ 'Logout' | translate }}</span
                                >
                            </div>
                        </a>
                    </li>
</ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>
